import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const SaseUyariGiris = () => {
    return (
        <>
            <ExcelUpload
                requiredColumnsSase={["sase", "warning"]}
                process_type="WARNING"
                ExcelName={"Saşe Uyarı Hatalı Şaseler"}
                Title={"Saşe Uyarı Yükle"}
                role_name={"sase_uyari_read"}
                exampleData={[
                    {
                        sase: "VF3YEF6F0RMA03711", warning: "TSE"
                    },
                ]}
            />
        </>
    )
}

export default SaseUyariGiris